// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__3oDfK","addbutton":"Record_addbutton__1Fm6_"};